import React, { useMemo } from 'react';
import { pushEvent } from '../../../utils/clevertapUtils';
import { CLICK_ORG_SEARCH_CANT_FIND_BTN } from '../../../utils/clevertapEvents';
import { PATH } from '../../../routes';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { useNavigate } from 'react-router-dom';
import { defaultOrganization } from '../../../store/signup/types';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link/Link';

export const maxSearchResultWidth = 950;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        infoStyles: {
            maxWidth: maxSearchResultWidth,
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: theme.spacing(0, 3),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                '& .organization-text': {
                    display: 'none',
                },
            },
        },
    }),
);

export const InfoRow: React.FC<{
    total?: number;
    organizationName: string;
}> = ({ total, organizationName }) => {
    const push = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { infoStyles } = useStyles();
    const { organizationText, foundText, organizationNotFound } = useMemo(
        () => ({
            organizationText: t(
                'signup.organizationSearch.organizationFound.organizations',
            ),
            foundText: t('signup.organizationSearch.organizationFound.found'),
            organizationNotFound: t(
                'signup.organizationSearch.organizationNotFound',
            ),
        }),
        [t],
    );
    const onClick = () => {
        dispatch(signSetAction(defaultOrganization));
        pushEvent(CLICK_ORG_SEARCH_CANT_FIND_BTN, { organizationName });
        push(PATH.SIGNUP.STEPS.ADD_ORGANIZATION);
    };
    return (
        <div className={infoStyles}>
            <div className="total">
                <b>{total || 0} </b>
                <span className="organization-text">{organizationText} </span>
                {foundText}
            </div>
            <Link onClick={onClick}>{organizationNotFound}</Link>
        </div>
    );
};
